const baseUrl = "https://athenaapi.appdeft.in/";
// const baseUrl = "http://localhost:3038/"; 
const endPointUrl = baseUrl + "api/user";
const apiUrl = baseUrl + "api"
const constants = { baseUrl, endPointUrl, apiUrl };

export default constants;